import { Injectable } from '@angular/core';

import { RestService } from "../../../../core/services/rest.service";

@Injectable()
export class MaterialServicoApiService {
    private apiName: string = 'materiais-servicos';

    constructor(
        private _restService: RestService
    ) { }

    onGetByServico(servicoId: number, done: any) {
        let filter: any = {"where":{"servicoId":servicoId},"include":[{"material":["medida"]}]};
        this._restService.onGetPost(this.apiName, filter, done);
    }

    onGetCustomFilter(filter: any, done: any) {
        filter.include = [{"material":["medida"]}];
        this._restService.onGetPost(this.apiName, filter, done);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/materiais/material-servico/shared/material-servico-api.service.ts
 **/